import { TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useState } from 'react'
import { useEffect } from 'react';

export default function SupDate({ onChange, item, onSave }) {
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (onSave) {
      setTouched(true);
    } else {
      setTouched(false);
    }

  }, [onSave]);

  const showError = item.isMandatory && touched && item.dateTimeValue === null;

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          disabled={item.disabled}
          componentsProps={{
            actionBar: { actions: ['clear', 'today'] },
          }}
          value={item.dateTimeValue || null}
          onChange={onChange}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              fullWidth
              sx={{
                color: item.disabled && 'black !important',
                backgroundColor: item.disabled && 'hsl(0, 0%, 95%)',
              }}
              error={showError}
              helperText={showError ? 'This field is required' : ''}
              inputProps={{
                ...params.inputProps,
                readOnly: true,  
                style: { fontSize: '1rem', height: 5 },
              }}
            />
          )}
          inputFormat={"DD/MM/YYYY"}
          maxDate={new Date()}  
        />
      </LocalizationProvider>

    </>
  );
}
